<template>
    <div class="form-group">
        <label class="form-label" :for="id" :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <a-date-picker
            :style="{ width: inputWidth, color: disabled ? '#adadad' : '#fff' }"
            :placeholder="placeholder"
            v-decorator="[name, { rules: rules }]"
            :format="format"
            :disabled="disabled"
            @change="handleDateChange"
            v-model="localModelValue"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: '请选择日期',
        },
        rules: {
            type: Array,
            default: () => [
                { required: true, message: '请选择日期' },
            ],
        },
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: true,
        },
        labelWidth: {
            type: String,
            default: '40%',
        },
        inputWidth: {
            type: String,
            default: '100%',
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD',
        },
        modelValue: {
            type: [String, null],
            default: null,
        },
        id: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            localModelValue: this.modelValue,
        };
    },
    watch: {
        modelValue: {
            immediate: true,
            handler(newValue) {
                if (newValue === null) {
                    this.localModelValue = null;
                } else if (newValue instanceof Date) {
                    this.localModelValue = this.$moment(newValue).format(this.format);
                } else {
                    this.localModelValue = newValue;
                }
            },
        },
        localModelValue: {
            handler(newValue) {
                this.$emit('update:modelValue', newValue);
            },
        },
    },
    methods: {
        handleDateChange(value) {
            if (value) {
                this.localModelValue = value.format(this.format);
            } else {
                this.localModelValue = null;
            }
        },
    },
};
</script>
<style scoped>
.form-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.form-label {
    display: block;
    color: #94a3b8;
    font-size: 0.9rem;
    width: 40%;
    white-space: nowrap;
}
::v-deep .ant-calendar{
    background-color: #0f2847;
}

::v-deep .ant-input{
    background-color: #0e1b34;
    border: 1px solid #0b4948;
    height: 45px;
    border-radius: 5px;
    color: #fff;
}
::v-deep .ant-calendar-picker-icon{
    color:rgba(255,255,255,0.25);
}

::v-deep .ant-input:hover{
    border-color: #0b4948;
}
::v-deep .ant-input[disabled]:hover{
   color: #adadad!important;
}
</style>